import router from "../../../router";
import axios from "axios";

export default {
    loadDocumentList({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['moreDocuments/getDocumentFilterFields'];
            let main_filter = this.getters['moreDocuments/getDocumentMainFilter'];

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setDocumentFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.documentNumber && router.currentRoute.query.document_number) {
                filter_fields.documentNumber = router.currentRoute.query.document_number;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentNumber', field_value: router.currentRoute.query.document_number})
            }

            if (!filter_fields.documentTitle && router.currentRoute.query.document_title) {
                filter_fields.documentTitle = router.currentRoute.query.document_title;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentTitle', field_value: router.currentRoute.query.document_title})
            }

            if (!filter_fields.documentUserName && router.currentRoute.query.document_user_name) {
                filter_fields.documentUserName = router.currentRoute.query.document_user_name;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentUserName', field_value: router.currentRoute.query.document_user_name})
            }

            if (!filter_fields.documentHash && router.currentRoute.query.document_hash) {
                filter_fields.documentHash = router.currentRoute.query.document_hash;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentHash', field_value: router.currentRoute.query.document_hash})
            }

            if (!filter_fields.documentClientId && router.currentRoute.query.document_client_id) {
                filter_fields.documentClientId = router.currentRoute.query.document_client_id;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentClientId', field_value: router.currentRoute.query.document_client_id})
            }

            if (!filter_fields.documentCreatedAt && router.currentRoute.query.document_created_at) {
                filter_fields.documentCreatedAt = router.currentRoute.query.document_created_at;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentCreatedAt', field_value: router.currentRoute.query.document_created_at})
            }

            if (!filter_fields.documentStatus && router.currentRoute.query.document_status) {
                filter_fields.documentStatus = router.currentRoute.query.document_status;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentStatus', field_value: router.currentRoute.query.document_status})
            }

            if (!filter_fields.documentDeleted && router.currentRoute.query.document_deleted) {
                filter_fields.documentDeleted = router.currentRoute.query.document_deleted;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentDeleted', field_value: router.currentRoute.query.document_deleted})
            }

            if (!filter_fields.documentCompanyId && router.currentRoute.query.document_company_id) {
                filter_fields.documentCompanyId = router.currentRoute.query.document_company_id;

                commit('setDocumentFilterFieldsMutation', {field_name: 'documentCompanyId', field_value: router.currentRoute.query.document_company_id})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/more-documents/list', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                commit('setDocumentList', response.data.data.result.documents);
                commit('setDocumentListCount', response.data.data.result.documents_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setDocumentFilterFields({ commit }, payload)
    {
        commit('setDocumentFilterFieldsMutation', payload);
    },
    deleteDocuments({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            axios.post('/api/document/delete-documents', {
                ids: payload
            }).then(response => {
                const result = response.data.data;

                if (response.data.data.result.success !== true) {
                    resolve(false);
                }

                commit('deleteDocumentsMutation', payload);

                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setDocumentModalOpen({commit}, payload)
    {
        commit('setDocumentModalOpenMutation', payload);
    },
    setDocumentIdAndDocumentIndexToModalForm({commit}, payload)
    {
        commit('setDocumentIdAndDocumentIndexToModalFormMutation', payload);
    },
    updateDocument({ commit }, payload)
    {
        commit('updateDocument', payload);
    },
    addDocumentToDocumentList({commit}, payload)
    {
        commit('addDocumentToDocumentList', payload);
    },
    updateDocumentExecutorStampDateTime({ commit }, payload)
    {
        commit('updateDocumentExecutorStampDateTime', payload);
    },
}
